import { Card } from "primereact/card";

const Dashboard = () => {


      return (
            <div>
                  <Card title="Dashboard">

                  <div style={{padding:"63% 0 0 0", position:"relative"}}>
                        <iframe title="overview"
                              src="https://app.databox.com/datawall/4099d9ef827c193bdd68b232e804dd55403059465c01aab?i" 
                              style={{ position:"absolute", "top":0, left:"0", width:"100%", height:"100%" }}
                              frameBorder="0" 
                              allowFullScreen>

                        </iframe>
                  </div>

                  <div style={{padding:"63% 0 0 0", position:"relative"}}>
                        <iframe title="rejections" src="https://app.databox.com/datawall/c9a9702bf7ac2e64c741777118713957275d2c465c06d40?i" 
                          style={{ position:"absolute", "top":0, left:"0", width:"100%", height:"100%" }}
                          frameBorder="0" 
                           allowFullScreen>

                          </iframe>
                    </div>
                  </Card>

            </div>
      )


};

export default Dashboard;